// extracted by mini-css-extract-plugin
module.exports =  {"container":"container__IS-vw","sectionTitle":"sectionTitle__zJbGx","description":"description__ItENr","list":"list__Lm-pU"};